import api from "../services/api";

export const getUserWhatsappPhoneNumbers = async (params = {}) => {
  return api.get("/api/whatsapp-accounts/phone-numbers", { params });
};

export const getWhatsappAccountCredentials = async (phoneId) => {
  return api.get(`/api/whatsapp-accounts/${phoneId}/credentials`);
};

export const previewWhatsappManualConnect = async ({
  phoneNumberId,
  accessToken,
  wabaId,
  metaAppId,
  metaAppSecret,
}) => {
  return api.post("/auth/facebook/manual-connect/preview", {
    phoneNumberId,
    accessToken,
    wabaId,
    metaAppId,
    metaAppSecret,
  });
};

export const debugWhatsappManualToken = async ({
  phoneNumberId,
  accessToken,
  syncToDb = false,
  metaAppId,
  metaAppSecret,
}) => {
  return api.post("/auth/facebook/manual-connect/debug-token", {
    phoneNumberId,
    accessToken,
    syncToDb,
    metaAppId,
    metaAppSecret,
  });
};

export const refreshWhatsappTokenDebug = async (
  phoneId,
  { accessToken, syncToDb = true, metaAppId, metaAppSecret } = {}
) => {
  return api.post(`/api/whatsapp-accounts/${phoneId}/refresh-token`, {
    accessToken,
    syncToDb,
    metaAppId,
    metaAppSecret,
  });
};

export const connectWhatsappManually = async ({
  wabaId,
  phoneNumberId,
  accessToken,
  phoneNumber,
  verifiedName,
  twoStepPin,
  metaAppId,
  metaAppSecret,
}) => {
  return api.post("/auth/facebook/manual-connect", {
    wabaId,
    phoneNumberId,
    accessToken,
    phoneNumber,
    verifiedName,
    twoStepPin,
    metaAppId,
    metaAppSecret,
  });
};

export const updateWhatsappManualCredentials = async ({
  phoneNumberId,
  accessToken,
  twoStepPin,
  metaAppId,
  metaAppSecret,
}) => {
  return api.put("/auth/facebook/manual-connect", {
    phoneNumberId,
    accessToken,
    twoStepPin,
    metaAppId,
    metaAppSecret,
  });
};

export const requestWhatsappVerificationCode = async (phoneId, method = "SMS") => {
  return api.post(`/api/whatsapp-accounts/request-code/${phoneId}`, { method });
};

export const verifyWhatsappCode = async (phoneId, code) => {
  return api.post(`/api/whatsapp-accounts/verify-code/${phoneId}`, { code });
};

export const registerPhoneWebhook = async (phoneId) => {
  return api.post(`/api/whatsapp-accounts/register/${phoneId}`, {});
};

export const getBusinessProfile = async (phoneId) => {
  return api.get(`/api/whatsapp-accounts/${phoneId}/business-profile`);
};

export const updateBusinessProfile = async (phoneId, fields) => {
  return api.patch(`/api/whatsapp-accounts/${phoneId}/business-profile`, fields);
};

export const uploadBusinessProfilePhoto = async (phoneId, file) => {
  const form = new FormData();
  form.append("photo", file);
  return api.post(`/api/whatsapp-accounts/${phoneId}/business-profile/photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getPhoneHealth = async (phoneId) => {
  return api.get(`/api/whatsapp-accounts/${phoneId}/health`);
};

export const syncPhoneHealth = async (phoneId) => {
  return api.post(`/api/whatsapp-accounts/${phoneId}/sync-health`, {});
};

export const syncAllPhoneHealth = async () => {
  return api.post(`/api/whatsapp-accounts/sync-health-all`, {});
};

export const refreshProfilePictures = async () => {
  return api.post(`/api/whatsapp-accounts/refresh-profile-pictures`, {});
};
